import { DEV } from "solid-js"
import { Vector3 } from "three"
import { freeze } from "../core/util/Object"

export const VERTICES_PER_TILE = 10
// export const VERTICES_PER_TILE = 32
export const HALF_VERTICES_PER_TILE = (VERTICES_PER_TILE / 2)

export const Y_AXIS_VECTOR = new Vector3(0, 1, 0)
export const X_AXIS_VECTOR = new Vector3(1, 0, 0)
export const Z_AXIS_VECTOR = new Vector3(0, 0, 1)

if (DEV) {
  freeze(Y_AXIS_VECTOR)
  freeze(X_AXIS_VECTOR)
  freeze(Z_AXIS_VECTOR)
}